import { getRoundedInput } from './getRoundedInput';

export const getDecrementedValue = (value: number, step: number, min: number, allowDecimal: boolean) => {
  const decrementedValue = value - step;
  const newValue = typeof min !== 'undefined' ? Math.max(decrementedValue, min) : decrementedValue;

  return getRoundedInput(newValue, allowDecimal);
};
